import { CreateNewLeadPopupCtrl } from './create.new.lead.popup.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('newlead', {
      url: '/newlead',
      template: '<ui-view/>',
    })
    .state('newlead.new', {
      url: '/new',
      controller: CreateNewLeadPopupCtrl,
      controllerAs: 'vm',
      templateUrl($stateParams) {
        return $stateParams.mobile
          ? new URL(
              'app/create.new.lead.popup/create.new.lead.mobile.html?raw',
              import.meta.url,
            )
          : new URL(
              'app/create.new.lead.popup/create.new.lead.popup.html?raw',
              import.meta.url,
            );
      },
      params: { phoneOrEmail: null, mobile: null },
    });
}
